import {
  ErrorBoundary,
  SearchInput,
  Icon,
  Text,
  NewAccordion,
  HStack,
  VStack,
} from '@genial/components';
import { Color, Spacing, Typography } from '@genial/design-tokens';
import { useNavigation } from '@react-navigation/native';
import { Box, Pressable } from 'native-base';
import React, { useState } from 'react';

import { SignedInNavigationScreenNavigationProp } from '../../routes/types';
import { useRateManagementActions } from '../../store/rateManagement/actions';

import { HeaderCards } from './components/HeaderCards';
import { HeaderSection } from './components/HeaderSection';
import { SentOrderList } from './components/SentOrderList';
import { SubHeader } from './components/SubHeader';
import { searchPlaceholder } from './constants';
import { RateManagementTypes } from './types';

export const ContainerMobile: React.FC<RateManagementTypes.Props> = ({
  isMobile,
  onClearSearchTerm,
  onSetSearchTerm,
  onRefresh,
  onLoadMore,
  sentOrders,
  sentOrdersLoading,
  sentOrdersError,
  searchTerm,
}) => {
  const [accordionState, setAccordionState] = useState('closed');

  const { downloadSpreadsheet } = useRateManagementActions();

  const navigation = useNavigation<SignedInNavigationScreenNavigationProp>();

  const handlePress = () => {
    setAccordionState(accordionState === 'closed' ? 'opened' : 'closed');
  };

  return (
    <VStack
      px={Spacing['inline.xxxs']}
      py={Spacing['inline.xxxs']}
      width="100%"
      minW="container"
      space={Spacing['inline.xxxs']}
      flex={1}>
      <HeaderSection isMobile={isMobile} />
      <SubHeader handlePress={handlePress} isMobile={isMobile} />
      <Box marginX="-16px">
        <HeaderCards carousel />
      </Box>
      <Box w="100%" bg="transparent" flex={1}>
        {sentOrdersError ? (
          <ErrorBoundary onRefresh={onRefresh} />
        ) : (
          <VStack flex={1}>
            <SearchInput
              isMobile
              isLoading={sentOrdersLoading}
              onClear={onClearSearchTerm}
              onSearch={onSetSearchTerm}
              placeholder={searchPlaceholder}
            />
            <SentOrderList
              isMobile
              hasSearch={!!searchTerm}
              sentOrders={sentOrders}
              sentOrdersLoading={sentOrdersLoading}
              onLoadMore={onLoadMore}
            />
          </VStack>
        )}
      </Box>
      {accordionState === 'opened' && (
        <NewAccordion handlePress={handlePress}>
          <VStack paddingX={Spacing['inline.xxxs']} space={Spacing['stack.xxs']}>
            <HStack flex={1} justifyContent={'space-between'}>
              <Text
                fontSize={Typography['fontsize.lg']}
                fontWeight={Typography['fontweight.semibold']}>
                Selecione uma opção:
              </Text>
              <Pressable onPress={handlePress}>
                <Icon color={Color['neutral.medium']} name="Close" size="xxs" testId="close-icon" />
              </Pressable>
            </HStack>

            <Pressable
              onPress={() => {
                navigation.navigate('RateManagementUpload');
                handlePress();
              }}>
              <Text
                fontSize={Typography['fontsize.lg']}
                fontWeight={Typography['fontweight.semibold']}>
                Importar planilha
              </Text>
            </Pressable>

            <Pressable
              paddingBottom={Spacing['stack.nano']}
              onPress={() => {
                downloadSpreadsheet();
                handlePress();
              }}>
              <Text
                fontSize={Typography['fontsize.lg']}
                fontWeight={Typography['fontweight.semibold']}>
                Exportar planilha
              </Text>
            </Pressable>
          </VStack>
        </NewAccordion>
      )}
    </VStack>
  );
};
